import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { DataSourceRequestState, DataResult } from '@progress/kendo-data-query';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppConstant } from 'src/app/app.constant';
import { Faculty } from './faculties.classes';
import { ToasterService, ToasterType } from 'src/app/services/toaster/toaster.service';
import { Attachment } from 'src/app/_metronic/core/classes/core.class';

@Injectable({
  providedIn: 'root'
})
export class FacultiesService {
  apiUrl: string;
  kendoDataUrl: string;
  constructor(private httpClient: HttpClient,
    private appConstant: AppConstant,
    private toasterService: ToasterService,
  ) {
    this.apiUrl = this.appConstant.getUrl()
  }
  get(customFilters) {
    return new Promise((resolve, reject) => {
      let params = {

      }
      this.httpClient.post(`${this.apiUrl}/getAllFaculty/`, customFilters).pipe(
        map(res => res))
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }
  public getAllFacultyKendo(gridSettings): Observable<DataResult> {
    return this.httpClient.post(`${this.apiUrl}/getAllFaculty/`, gridSettings).pipe(
      map((response: any) => {
        return {
          data: response.data,
          total: response.total
        } as GridDataResult
      })
    ) as any as Observable<GridDataResult>
  }
  public getAllFacultyNames(gridSettings): Observable<DataResult> {
    return this.httpClient.post(`${this.apiUrl}/getAllFacultyName/`, gridSettings).pipe(
      map((response: any) => {
        return {
          data: response.data,
          total: response.total
        } as GridDataResult
      })
    ) as any as Observable<GridDataResult>
  }

  async getAllFacultyOnlyName() : Promise<any[]> {
    return (await this.httpClient.get<GridDataResult>(`${this.apiUrl}/getAllFacultyName/`).toPromise()).data;
}

  public downloadExcelFaculty() {
    return new Promise((resolve, reject) => {
      this.httpClient.get(`${this.apiUrl}/downloadExcelFaculty`, { responseType: 'blob' }).pipe(
        map(res => res))
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          if (err.status == 403) {
            this.toasterService.showToaster(null, "No data found!", ToasterType.Error)
          }
          reject(err);
        });
    });
  }

  manageFaculty(faculty: Faculty) {
    return this.httpClient.post(`${this.apiUrl}/manageFaculty`, faculty).pipe(
      map((response: any) => {
        return response;
      })
    )
  }

  bulkInsert(FacultyData) {
    return this.httpClient.post(`${this.apiUrl}/bulkImportFaculty`, FacultyData).pipe(
      map((response: any) => {
        return response;
      })
    )
  }
  bulkDeleteFaculty(facultyData) {
    let params = {
      DataToDelete: facultyData
    }
    return this.httpClient.post(`${this.apiUrl}/bulkDeleteFaculty`, params).pipe(
      map((response: any) => {
        return response;
      })
    )
  }
  getById(id: number) {
    return this.httpClient.get(`${this.apiUrl}/getFacultyById/` + id).pipe(
      map((response: any) => {
        return response;
      })
    )
  }
  getFacultyByClassId(classId: number) {
    return this.httpClient.get(`${this.apiUrl}/classfacultyList/` + classId).pipe(
      map((response: any) => {
        return {
          data: response.data,
        } as GridDataResult
      })
    ) as any as Observable<GridDataResult>;
  }

  getFacultyBySubjectId(subjectId: number) {
    return this.httpClient.get(`${this.apiUrl}/subjectfacultyList/` + subjectId).pipe(
      map((response: any) => {
        return {
          data: response.data,
        } as GridDataResult
      })
    ) as any as Observable<GridDataResult>;
  }
  getFacultyClassAndSubjectList(classId: number) {
    return new Promise((resolve, reject) => {
      this.httpClient.get(`${this.apiUrl}/facultyClassAndSubjectList/` + classId).pipe(
        map(res => res))
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }
  
  manageFacultyAssignment(opinionPoll) {
    return this.httpClient.post(`${this.apiUrl}/manageFacultyAssignment`, opinionPoll).pipe(
      map((response: any) => {
        return response;
      })
    )
  }
  getAllFacultyAssignmentById(id) {
    return this.httpClient.get(`${this.apiUrl}/getFacultyById/` + id).pipe(
      map((response: any) => {
        return response;
      })
    )
  }

  
  GetFacultySettings() {
    return this.httpClient.get(`${this.apiUrl}/getFacultySettings`).pipe(
        map((response: any) => {
            return response;
        })
    );
  }

  ManageFacultySettings(data) {
    return this.httpClient.post(`${this.apiUrl}/manageFacultySettings`, data).pipe(
        map((response: any) => {
            return response;
        })
    );
  }
  addAttachments(attachments: Attachment[]) {
    return new Promise((resolve, reject) => {
      this.httpClient.post(`${this.apiUrl}/fileBulkUpload`, attachments).pipe(
        map(res => res))
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }
  uploadProfilePicture(data) {
    return new Promise((resolve, reject) => {
      this.httpClient.post(`${this.apiUrl}/uploadProfilePicture`, data).pipe(
        map(res => res))
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }
}

